<template>
  <div class="grid-x grid-padding-x align-center">
    <div class="cell medium-12 large-3 small-order-2 large-order-1">
      <block-transfer-search-filters-component
        :nonce="nonce"
        :apiUrls="apiUrls"
        ref="searchFiltersComponentRef"
        @onSubmit="submit"
        is-on-results-page="true"
        base-page-path="/transfer-options/search-programs/"
        results-page-path="/transfer-options/search-programs/result-block-transfer/"
      >
      </block-transfer-search-filters-component>
    </div>

    <div class="cell medium-12 large-9 small-order-1 large-order-2 o-search-result">
      Search Result
      <div class="o-search-results">
        <div class="o-search-results__header s-content-block s-content-block--small">
          <div class="o-search-results__title">
            <h3>Block Transfer</h3>
            <div class="o-search-results__button">
              <form id="save-to-pdf-form" target="_blank" method="POST"></form>
              <button
                type="button"
                class="a-button a-button--small a-button--primary-outline"
                @click="downloadPdf"
              >
                Save to PDF
              </button>
              <button type="button" class="a-button a-button--small" @click="newSearch">
                New Search
              </button>
            </div>
          </div>
        </div>
        <div class="s-content-block s-content-block--small">
          <div class="o-search-result__table-total-page">
            <div class="text-center medium-text-left">
              {{ pageFrom }} to {{ pageTo }} of {{ totalAgreements }} matches <br />
            </div>
            <ul class="pagination" v-if="totalPages > 1">
              <li
                :class="['page-item', { disabled: currentPage === 1 }]"
                :disabled="currentPage === 1"
              >
                <button
                  :class="['page-link', { disabled: currentPage === 1 }]"
                  :disabled="currentPage === 1"
                  @click="goToFirstPage"
                >
                  First
                </button>
              </li>
              <paginate
                v-model="currentPage"
                :page-count="totalPages"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
                <template #page="{ page, selected, disabled }">
                  <li :class="{ selected: selected }">
                    <button :disabled="disabled" @click="pageClick(page)">
                      {{ page }}
                    </button>
                  </li>
                </template>
              </paginate>
              <li
                :class="['page-item', { disabled: currentPage === totalPages }]"
                :disabled="currentPage === totalPages"
              >
                <button
                  :class="['page-link', { disabled: currentPage === totalPages }]"
                  :disabled="currentPage === totalPages"
                  @click="goToLastPage"
                >
                  Last
                </button>
              </li>
            </ul>
          </div>
          <div class="o-search-results__table-wrapper">
            <span class="a-text-small"></span>
            <div
              v-if="
                searchResponse.agreements != null && _.get(searchResponse, 'agreements.length') > 0
              "
              class="o-search-results__table"
            >
              <!-- Headers -->
              <div class="o-search-results__table-header o-search-results__table-header-program">
                <div class="grid-x">
                  <div class="cell small-2"><strong>From Institution</strong></div>
                  <div class="cell small-2"><strong>Program</strong></div>
                  <div class="cell small-2"><strong>To Institution</strong></div>
                  <div class="cell small-2"><strong>Program</strong></div>
                  <div class="cell small-2"><strong>Transfer Credit</strong></div>
                  <div class="cell small-2"><strong>Academic Year</strong></div>
                </div>
              </div>

              <div class="o-search-results__table-row block-transfer">
                <div
                  class="grid-x"
                  v-for="agreement in searchResponse.agreements"
                  :key="agreement.id"
                >
                  <!-- FROM -->
                  <div class="cell small-2">
                    <!-- From Institution -->
                    <div class="flex-container">
                      <div
                        class="o-search-results__logo"
                        :data-tooltip="agreement.senderInstitutionName"
                      >
                        <img :src="`${logosUrl}/${agreement.sndrGlobalInstitutionID}_icon.png`" />
                      </div>
                      <span>{{ agreement.senderInstitutionCode }}</span>
                    </div>
                  </div>

                  <!-- From Program -->
                  <div class="cell small-2">
                    <div class="flex-container">
                      <span>{{ agreement.senderProgramName }}</span>
                    </div>
                  </div>

                  <!-- TO -->
                  <div class="cell small-8 cell-no-padding">
                    <div class="grid-x" v-for="toProgram in agreement.programs" :key="toProgram.id">
                      <!-- To institution -->
                      <div class="cell small-3">
                        <div class="flex-container">
                          <div
                            class="o-search-results__logo"
                            :data-tooltip="toProgram.receiverInstitutionName"
                          >
                            <img
                              :src="`${logosUrl}/${toProgram.rcvrGlobalInstitutionID}_icon.png`"
                            />
                          </div>
                          <span>{{ toProgram.receiverInstitutionCode }}</span>
                        </div>
                      </div>

                      <!-- To Program -->
                      <div class="cell small-3">
                        {{ toProgram.receiverProgramName }}
                      </div>

                      <!-- Transfer Credit -->
                      <div class="cell small-3" style="display: block">
                        {{ toProgram.creditDetail }}
                        <span class="o-search-results__note" v-if="toProgram.condition">
                          <strong>Note:</strong> {{ toProgram.condition }}</span
                        >
                      </div>

                      <!-- Academic Year -->
                      <div class="cell small-3">
                        {{ toProgram.startYear }} - {{ toProgram.endYear }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h6 v-else-if="_.get(searchResponse, 'agreements.length') == 0">
              There are no transfer agreements for that search. Please try again.
            </h6>
          </div>
          <div class="o-search-result__table-page">
            <ul class="pagination" v-if="totalPages > 1">
              <li
                :class="['page-item', { disabled: currentPage === 1 }]"
                :disabled="currentPage === 1"
              >
                <button
                  :class="['page-link', { disabled: currentPage === 1 }]"
                  :disabled="currentPage === 1"
                  @click="goToFirstPage"
                >
                  First
                </button>
              </li>
              <paginate
                v-model="currentPage"
                :page-count="totalPages"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
                <template #page="{ page, selected, disabled }">
                  <li :class="{ selected: selected }">
                    <button :disabled="disabled" @click="pageClick(page)">
                      {{ page }}
                    </button>
                  </li>
                </template>
              </paginate>
              <li
                :class="['page-item', { disabled: currentPage === totalPages }]"
                :disabled="currentPage === totalPages"
              >
                <button
                  :class="['page-link', { disabled: currentPage === totalPages }]"
                  :disabled="currentPage === totalPages"
                  @click="goToLastPage"
                >
                  Last
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, watch } from 'vue'
import BlockTransferSearchFiltersComponent from './BlockTransferSearchFiltersComponent.vue'
import Paginate from 'vuejs-paginate-next'
import axios from 'axios'
import _ from 'lodash'

const props = defineProps({
  nonce: { type: String, required: true },
  logosUrl: { type: String, required: true },
  apiUrls: { type: Object, required: true },
})

const searchResponse = reactive({
  agreements: null,
})

const searchFiltersComponentRef = ref(null)

const searchRequestCancelToken = ref(null)
const pdfRequestCancelToken = ref(null)
const pageLength = ref(null)
const pageFrom = ref(null)
const pageTo = ref(null)
const currentPage = ref(1)
const totalPages = ref(0)
const totalAgreements = ref(0)
const currentFilterData = reactive({})

const goToFirstPage = () => {
  currentPage.value = 1
}

const goToLastPage = () => {
  currentPage.value = totalPages.value
}

watch(currentPage, (newCurrentPage, old) => {
  if (newCurrentPage === old || (newCurrentPage === 1 && old === null)) {
    return
  }

  const data = _.clone(currentFilterData)
  _.set(data, 'pageNumber', newCurrentPage)

  submit(data)
})

function submit(data) {
  // if pageNumber is not in data, reset it
  Object.assign(currentFilterData, _.clone(data))
  if (data && !Object.prototype.hasOwnProperty.call(data, 'pageNumber')) {
    delete currentFilterData.pageNumber
  }

  searchRequestHandler(
    `/wp-json/bctg-search/block-transfer/agreements?_wpnonce=${props.nonce}`,
    currentFilterData,
  )
}

function searchRequestHandler(path, params) {
  if (searchRequestCancelToken.value) {
    searchRequestCancelToken.value.cancel()
  }

  searchRequestCancelToken.value = axios.CancelToken.source()
  searchResponse.agreements = null

  document.body.classList.add('js-is-searching')
  $('html, body').animate({ scrollTop: $('.js-header').offset().top + 200 }, '400')

  axios
    .post(path, params, {
      cancelToken: searchRequestCancelToken.value.token,
    })
    .then((response) => searchResponseHandler(response))
}

const searchResponseHandler = (response) => {
  Object.assign(searchResponse, response.data)
  document.body.classList.remove('js-is-searching')

  const attributes = {
    currentPage,
    totalPages,
    totalAgreements,
    pageLength,
    pageFrom,
    pageTo,
  }

  Object.keys(attributes).forEach((key) => {
    const value = _.get(searchResponse, key)
    if (value !== attributes[key].value) {
      attributes[key].value = value
    }
  })
}

function downloadPdf(event) {
  event.preventDefault()

  const saveToPdfFormElement = document.getElementById('save-to-pdf-form')
  saveToPdfFormElement.action = `/wp-json/bctg-search/block-transfer/agreements/pdf?_wpnonce=${props.nonce}`
  saveToPdfFormElement.innerHTML = ''

  Object.entries(currentFilterData).forEach(([paramName, paramValue]) => {
    const newInput = document.createElement('input')
    newInput.type = 'hidden'
    newInput.id = paramName
    newInput.name = paramName
    newInput.value = paramValue
    saveToPdfFormElement.append(newInput)
  })

  saveToPdfFormElement.submit()
}

function newSearch() {
  searchFiltersComponentRef.value.newSearch()
}
</script>
